export default "__VITE_ASSET__BhzYvhhI__"